import { GetInternalLinkFunctionType } from '@repo/models/GetInternalLinkFunctionType';
import { LocaleCurrencyEnum } from '@repo/models/LocaleCurrencyEnum';
import { getLocalizedPagePath } from '@repo/gatsby-localization-helpers';

// Check if Anchor exists and add it to the url
const getSlugWithAnchor = (slug: string, anchor: string) =>
  anchor ? `${slug}#${anchor}` : slug;

const getTranslatedSlug = (slug: string, currency: string) => {
  let localeSlug = slug;

  if (currency === LocaleCurrencyEnum.CAD) {
    localeSlug = `/en-ca${localeSlug}`;
  }

  return localeSlug;
};

const getInternalLink: GetInternalLinkFunctionType = ({
  slug,
  currency = LocaleCurrencyEnum.USD,
  anchor,
  locale,
}) => {
  if (locale) {
    return getLocalizedPagePath(getSlugWithAnchor(slug, anchor), locale);
  }

  if (currency) {
    return getTranslatedSlug(getSlugWithAnchor(slug, anchor), currency);
  }

  return slug;
};

export default getInternalLink;
